/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalHoldRequest
 */
export interface LegalHoldRequest {
    /**
     * Enable or disable legal hold
     * @type {boolean}
     * @memberof LegalHoldRequest
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the LegalHoldRequest interface.
 */
export function instanceOfLegalHoldRequest(value: object): value is LegalHoldRequest {
    return true;
}

export function LegalHoldRequestFromJSON(json: any): LegalHoldRequest {
    return LegalHoldRequestFromJSONTyped(json, false);
}

export function LegalHoldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalHoldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function LegalHoldRequestToJSON(json: any): LegalHoldRequest {
    return LegalHoldRequestToJSONTyped(json, false);
}

export function LegalHoldRequestToJSONTyped(value?: LegalHoldRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

